import React from "react";
import PropTypes from "prop-types";
import { Button, Dialog, Typography } from "@mui/material";
import clsx from "clsx";

import { getRelationKeyByValue } from "utils/relativeUtils";
import { FACE_RELATIONS } from "enums";
import { useFaces, useFaceOrg } from "hooks";
import SpinningCloseButton from "components/SpinningCloseButton";
import ResponsiveImage from "components/ResponsiveImage";
import { MODAL_CONTENT } from "utils/ctaUtils";

import useStyles from "./useStyles";

const CTAModal = (props) => {
  const { relation, onClose } = props;
  const classes = useStyles();
  const { openModal: openFacesModal, clearRelationToCreate } = useFaces();

  const img = MODAL_CONTENT.img[relation];
  const title = MODAL_CONTENT.title[relation];
  const description = MODAL_CONTENT.description[relation];
  const { clearEntryPoint } = useFaceOrg();

  const handleClose = () => {
    clearRelationToCreate();
    onClose();
    clearEntryPoint();
  };

  const handleOpenModal = () => {
    openFacesModal();
    onClose();
  };

  return (
    <Dialog
      classes={{ root: classes.root }}
      PaperProps={{ classes: { root: clsx(classes.paper, classes[getRelationKeyByValue(relation)]) } }}
      open
      onBackdropClick={handleClose}
    >
      <SpinningCloseButton className={classes.buttonClose} onClick={handleClose} />

      <div className={classes.content}>
        <figure className={classes.figure}>
          <ResponsiveImage src={img} alt={title} className={classes.image} width={128} widthMobile={128} />
        </figure>

        <Typography align="center" variant="h4" className={classes.title}>
          {title}
        </Typography>
        <Typography variant="large" align="center" className={classes.description}>
          {description}
        </Typography>

        <Button variant="contained" onClick={handleOpenModal}>
          Add Face
        </Button>
      </div>
    </Dialog>
  );
};

CTAModal.propTypes = {
  relation: PropTypes.oneOf(Object.values(FACE_RELATIONS)).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default CTAModal;
